module.exports = __webpack_public_path__ + "img/size-estimator_vn.e187ef3d.png";